export default __webpack_public_path__ + "static/media/bulbIcon.be55f7dd.svg";